import { useEffect, RefObject } from "react";

interface UseIntersectionObserver {
  targetRef: RefObject<Element>;
  options: IntersectionObserverInit;
  callback: IntersectionObserverCallback;
}

function useIntersectionObserver({
  targetRef,
  options,
  callback,
}: UseIntersectionObserver) {
  useEffect(() => {
    const target = targetRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(callback, options);
    observer.observe(target);

    return () => {
      if (observer) {
        observer.unobserve(target);
      }
    };
  }, [targetRef, options, callback]);
}

export default useIntersectionObserver;
